module.exports = __webpack_public_path__ + "img/jhw_border.5139b68a.png";